const Juridical = [
    {id: "0", value: "三大法人"},    
    {id: "1", value: "外資及陸資"},
    {id: "2", value: "投信"},
    {id: "3", value: "自營商"}
  ];  
  
  export default Juridical